import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-statistique-rembourse',
  templateUrl: './statistique-rembourse.component.html',
  styleUrls: ['./statistique-rembourse.component.scss']
})
export class StatistiqueRembourseComponent implements OnInit {

  constructor(private router: Router) { }

  ngOnInit() {
  }

  RemboursementAgent(id:number){   
    this.router.navigate(['statistic-rembours-agent/']);
  }

  RemboursementTraite(id:number){   
    this.router.navigate(['statistic-rembours-traite/'+id]);
   }

}
